import React, {
  createContext,
  useContext,
  ReactNode,
  Dispatch,
  useReducer,
} from 'react';
import UAParser from 'ua-parser-js';

interface State {
  mobileSignupCompleted: boolean;
}

interface IMobileContext {
  state: State;
  isMobile: boolean;
  dispatch: Dispatch<Partial<State>>;
}

interface Props {
  children?: ReactNode;
}

const initialState: State = {
  mobileSignupCompleted: false,
};

const reducer = (state: State, updates: Partial<State>): State => {
  return { ...state, ...updates };
};

const MobileContext = createContext<IMobileContext>({
  dispatch: () => {},
  state: initialState,
  isMobile: false,
});

export const useMobile = () => {
  return useContext(MobileContext);
};

export const MobileProvider = ({ children }: Props) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const {
    device: { type },
  } = UAParser();

  const value = {
    state,
    dispatch,
    isMobile: type === 'mobile',
  };

  return (
    <MobileContext.Provider value={value}>{children}</MobileContext.Provider>
  );
};
